module.exports = __webpack_public_path__ + "static/media/00.61cfd6a6.png";